import React, { Component } from 'react';
import Question from './Question';
import '../App.css';

class QuizQuestions extends Component {
    constructor(props) {
        super(props);
        this.state = {
           ids : [],
           attempts: [],
          };
    }

    async componentDidMount() {
        const urlString = this.keyValuesConstruct()
        const {amount} = this.props.state;
        const response = await fetch(`https://opentdb.com/api.php?amount=${amount}${urlString}`);
        if(response){
            const json = await response.json();
            if (json.response_code===0){
                this.questions = await json.results
            }
        }    
        this.props.toggleLoading();
    }

    componentWillUnmount(){
        const {attempts, ids} = this.state;
        this.props.captureResults(attempts, ids);
    }

    addCorrectAttempts = (optionValue, correctAnswer,  bool, id)=>{
        if (!(id in this.state.ids)){
            this.setState({
                ids: [...this.state.ids, id]
            })
            this.setState({
                attempts:[
                    ...this.state.attempts,
                    {
                        optionValue,
                        correctAnswer,
                        id,
                        bool
                    }
                ]
            })
        } else{
            let attempts = this.state.attempts;
            attempts.forEach((attempt)=>{
                if (attempt.id=== id){
                    attempt.optionValue = optionValue;
                    attempt.bool = bool
                }
            })
            this.setState({
                attempts:attempts
            })
        }
    }

    keyValuesConstruct(){
        let string = ''
        const {category, difficulty, type} = this.props.state;
        const insufficientQs = ['13', '19', '24', '25', '27', '29', '30']
        if(category!== 'any'){
            string+= `&category=${category}`
        }
        if(difficulty!== 'any' && !(insufficientQs.includes(category))){
            string+= `&difficulty=${difficulty}`
        }
        if(type!== 'any' && !(insufficientQs.includes(category))){
            string+= `&type=${type}`
        }
        return string
    }  

    render() {
        const {type, difficulty, loading} = this.props.state;
        return(
            <div className = "QuizQuestions">
                {!loading &&
                    <form onSubmit = {this.props.handleAnswerSubmit} className = "answer-container bg-white p-4 mt-5 rounded">
                        <h1 className = "h3 text-muted text-center quiz-heading">{type} choice type Quiz ({difficulty} Difficulty)</h1>
                        <hr/>
                        {this.questions?(
                            this.questions.map((question, index)=>(
                                <Question 
                                    question = {question} 
                                    key ={index} 
                                    questionID = {index} 
                                    addCorrectAttempts = {this.addCorrectAttempts}
                                />
                                ))
                        ):(
                            <p>Sorry!! We found insufficient results for your query.
                                Try lowering number of questions or set the category and difficulty to 'Any'
                            </p>
                        )}
                        <button type ="submit" className = "btn btn-secondary submit-button mt-3">Submit</button>
                    </form>
                    
                }
           </div>
        )
    }
}


export default QuizQuestions;